import { NotificationListResource } from 'dy-frontend-http-repository/lib/modules/Notification/resources';
import domain from './domain';
import { resetNotifications } from './events';

// Notifications
export const $notifications = domain.createStore<NotificationListResource | null>(null).reset(resetNotifications);
